import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTable, useSortBy, usePagination, useFilters } from 'react-table';

import { TextFilter, RangeFilter } from 'components/Shared/Filters';
import { getQuestionInfo } from 'questions';

import Questions from './Questions';
import styles from './Questions.module.scss';

const cx = classNames.bind(styles);

const QuestionsContainer = ({ questions, ...props }) => {
  const { t } = useTranslation();
  const columns = useMemo(
    () => [
      {
        Header: '',
        accessor: 'index',
        disableFilters: true,
        disableSortBy: true,
      },
      {
        accessor: 'type',
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => {
          const questionInfo = getQuestionInfo(value);
          return <img alt="" className={cx('icon')} src={questionInfo.icon} />;
        },
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: t('Course/Teacher/Statistics/Questions/_title'),
        accessor: 'title',
        Filter: TextFilter,
        filter: 'text',
      },
      {
        Header: t('Course/Teacher/Statistics/Questions/rate'),
        accessor: 'rate',
        Cell: ({ value }) => `${value}%`,
        Filter: RangeFilter,
        filter: 'between',
      },
    ],
    [t],
  );
  const data = useMemo(
    () =>
      questions.map((question, index) => ({
        ...question,
        index: index + 1,
      })),
    [questions],
  );
  const filterTypes = React.useMemo(
    () => ({
      text: (rows, id, filterValue) =>
        rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .includes(String(filterValue).toLowerCase())
            : true;
        }),
    }),
    [],
  );
  const table = useTable(
    {
      columns,
      data,
      filterTypes,
      initialState: {
        pageIndex: 0,
        pageSize: 10,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
  );
  const count = questions.length;
  const [isSectionOpen, SetIsSectionOpen] = useState(false);
  const handleSectionToggle = useCallback(() => {
    SetIsSectionOpen(!isSectionOpen);
  }, [isSectionOpen]);
  return (
    <Questions
      count={count}
      handleSectionToggle={handleSectionToggle}
      isSectionOpen={isSectionOpen}
      t={t}
      table={table}
      {...props}
    />
  );
};

QuestionsContainer.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default QuestionsContainer;
